<p>You have been inactive for 15 minutes, do you want to continue using your session?</p>
<p class="text-timer text-center">{{ timer }}</p>
<mat-dialog-actions>
  <button class="btn btn-lg btn-greengo" mat-button mat-dialog-close (click)="reset()">Yes</button>
</mat-dialog-actions>
